// extracted by mini-css-extract-plugin
export default {"landingBanner":"landingPageBanner_landingBanner__ubD5u"};